import { render, staticRenderFns } from "./ItemLocationSelectInputWidget.vue?vue&type=template&id=c58c3fca&scoped=true"
import script from "./ItemLocationSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./ItemLocationSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c3fca",
  null
  
)

export default component.exports